module.exports = __webpack_public_path__ + "img/avatar-female.519fbc80.png";